export var ValidationMessageCssClass;
(function (ValidationMessageCssClass) {
    ValidationMessageCssClass["Base"] = "iress-validation-message";
    ValidationMessageCssClass["Error"] = "iress-validation-message--error";
    ValidationMessageCssClass["Warning"] = "iress-validation-message--warning";
    ValidationMessageCssClass["Success"] = "iress-validation-message--success";
    ValidationMessageCssClass["Info"] = "iress-validation-message--info";
    ValidationMessageCssClass["Wrapper"] = "iress-validation-message__wrapper";
    ValidationMessageCssClass["Prefix"] = "iress-validation-message__prefix";
    ValidationMessageCssClass["PrefixHidden"] = "iress-validation-message__prefix--hidden";
    ValidationMessageCssClass["Message"] = "iress-validation-message__message";
})(ValidationMessageCssClass || (ValidationMessageCssClass = {}));
//# sourceMappingURL=validation-message.types.js.map